import { OnlinePaintTool } from '@/features/online-paint'

export function OnlinePaintPage() {
  return <OnlinePaintTool />
}
